import {Box, styled} from '@mui/material';

import {COLLAPSED_HEIGHT, HOUR_LIST_ROW_GAP} from './constants';
import {StyledHourListProps} from './types';

export const StyledHourList = styled(Box)<StyledHourListProps>`
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	gap: ${HOUR_LIST_ROW_GAP}px 12px;
	overflow: hidden;
	max-height: ${({$isExpanded}) => ($isExpanded ? 'none' : `${COLLAPSED_HEIGHT}px`)};

	${({theme}) => theme.breakpoints.up('sm')} {
		grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));
	}
`;
